<template>
   <div class="container">
     <Header  activeIndex="0" />
     <div id="luxy">
       <div class="section01">
         <div class="bg luxy-el" data-speed-y="40">
           <bannerComponent :banner="data.banner"></bannerComponent>
         </div>
       </div>
       <div class="section02">
          <div class="bg luxy-el" data-speed-y="20">
          </div>
         <div class="content">
           <div class="t1">
             入驻单位
           </div>
           <div class="nr">
             <div class="l">
               <div class="types">
                 <p v-for="(item,index) in types" :key="index" :class="{'active':tindex==index}" @click="goSlide(index)">{{item}}</p>
               </div>
               <div class="sw1">
                 <swiper :options="swiperOption1" ref="mySwipers" class="swiper">
                   <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                     <div class="text">
                       <p class="p1">用户至上   |    服务第一</p>
                       <div class="des">
                         浙江省宁波新能源汽车产业创新服务综合体采用“市场化运作的一站式服务平台”管理模式，以宁波杭州湾新区经济和信息化局为主管单位，宁波杭州湾新材料研究院为建设运营单位，联合吉利汽车研究院、宁波杭州湾新区龙湾创新服务中心、中汽研汽车检验中心（宁波）有限公司、各汽车零部件公司等，整合高新园区、汽车智创小镇、共享智联小镇，构建开放、协同、高效的科技创新服务平台。
                       </div>
                       <div class="more">
                         <img src="../assets/jt.png" alt="">
                         <p>了解更多</p>
                       </div>
                     </div>
                   </swiper-slide>
                 </swiper>
               </div>
               <div class="btns">
                  <div class="prev">
                    <img src="../assets/jh.png" alt="">
                    <img src="../assets/jb.png" alt="">
                  </div>
                 <div class="next">
                   <img src="../assets/jh.png" alt="">
                   <img src="../assets/jb.png" alt="">
                 </div>
               </div>
             </div>
             <div class="r">
               <swiper :options="swiperOption2" ref="mySwipers2" class="swiper">
                 <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                   <div class="pic">
                     <img :src="item.img" alt="">
                   </div>
                 </swiper-slide>
               </swiper>
             </div>
           </div>
         </div>
       </div>
       <div class="section03">
         <div class="content">
           <div class="t1">
             <div class="l">
               新闻动态
             </div>
             <div class="r">
               <a href="" class="active">通知公告</a>
               <a href="">新闻资讯</a>
               <a href="">政策文件</a>
               <a href="">行业热点</a>
             </div>
           </div>
           <div class="rnews">
             <p class="p1">最新动态 ——2022.4.4</p>
             <p class="p2">​宁波杭州湾新材料研究院入选省级新型研发机构。</p>
             <div class="btn">
               <img src="../assets/jt.png" alt="">
               <p>查看详情</p>
             </div>
           </div>
         </div>
         <div class="allNews">
           <div class="item">
             <p class="p1">24</p>
             <p class="p2">2022.3</p>
             <p class="p3">​宁波杭州湾新材料研究院入选省级 新型研发机构...</p>
             <div class="des">
               2021年12月31日，浙江省科技厅公布2021年度省级新型研发机构名单 ，新区研究机构宁波杭州湾新材料研究院...
             </div>
             <div class="btn">
               <img src="../assets/jt.png" alt="">
               <p>查看详情</p>
             </div>
             <div class="bg">
               <img src="../assets/newsb.png" alt="">
             </div>
           </div>
           <div class="item">
             <p class="p1">24</p>
             <p class="p2">2022.3</p>
             <p class="p3">​宁波杭州湾新材料研究院入选省级 新型研发机构...</p>
             <div class="des">
               2021年12月31日，浙江省科技厅公布2021年度省级新型研发机构名单 ，新区研究机构宁波杭州湾新材料研究院...
             </div>
             <div class="btn">
               <img src="../assets/jt.png" alt="">
               <p>查看详情</p>
             </div>
             <div class="bg">
               <img src="../assets/newsb.png" alt="">
             </div>
           </div>
           <div class="item">
             <p class="p1">24</p>
             <p class="p2">2022.3</p>
             <p class="p3">​宁波杭州湾新材料研究院入选省级 新型研发机构...</p>
             <div class="des">
               2021年12月31日，浙江省科技厅公布2021年度省级新型研发机构名单 ，新区研究机构宁波杭州湾新材料研究院...
             </div>
             <div class="btn">
               <img src="../assets/jt.png" alt="">
               <p>查看详情</p>
             </div>
             <div class="bg">
               <img src="../assets/newsb.png" alt="">
             </div>
           </div>
         </div>
         <div class="gd">
            <p>更多动态</p>
         </div>
       </div>
       <div class="section04">
         <div class="bg luxy-el" data-speed-y="5"></div>
          <div class="content">
             <div class="t1">
               龙头企业及各大院名校
             </div>
            <div class="t2">
              科技中介服务机构申请、政策补贴申请等窗口
            </div>
            <div class="pics">
               <div class="item">
                 <img src="../assets/b1.png" alt="">
               </div>
              <div class="item">
                <img src="../assets/b2.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b2.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b2.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b2.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b2.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b2.png" alt="">
              </div>
              <div class="item">
                <img src="../assets/b1.png" alt="">
              </div>
            </div>
          </div>
       </div>
       <div class="section05">
         <div class="bg luxy-el" data-speed-y="10"></div>
           <div class="content">
             <div class="t1">
               服务申请
             </div>
             <div class="t2">
               科技中介服务机构申请、政策补贴申请等窗口，<br>
               后期可按需随时自由调整申请窗口名称、数量。申请采用在线填报信息，<br>
               可生成pfd文档供申请者预览和下载，点击提交后由管理员对资质进行审核，<br>
               通过填报预留手机短信通知审核结果。
             </div>
             <a href="" class="more">
               <img src="../assets/jt.png" alt="">
               <p>了解更多</p>
             </a>
             <div class="allItems">
               <div class="item">
                 <div class="d1">
                   <div class="l">
                     <div class="pic">
                       <img src="../assets/fw11.png" alt="">
                     </div>
                     <p>入驻申请</p>
                   </div>
                   <div class="r">
                     <p class="p1">商业供应链管理系统和专业体系能力建设，<br>
                       为企业打造智能解决方案</p>
                     <div class="des">
                       通过众多智能平台与工具，为供应链提供一体化个性解决方案，帮助企业走向智能化、合规化运营... ..
                     </div>
                   </div>
                 </div>
                 <div class="d2">
                   <img src="../assets/jt.png" alt="">
                   <p>探索更多</p>
                 </div>
               </div>
               <div class="item">
                 <div class="d1">
                   <div class="l">
                     <div class="pic">
                       <img src="../assets/fw11.png" alt="">
                     </div>
                     <p>入驻申请</p>
                   </div>
                   <div class="r">
                     <p class="p1">商业供应链管理系统和专业体系能力建设，<br>
                       为企业打造智能解决方案</p>
                     <div class="des">
                       通过众多智能平台与工具，为供应链提供一体化个性解决方案，帮助企业走向智能化、合规化运营... ..
                     </div>
                   </div>
                 </div>
                 <div class="d2">
                   <img src="../assets/jt.png" alt="">
                   <p>探索更多</p>
                 </div>
               </div>
             </div>
           </div>
       </div>
       <div class="section06" >
         <div class="bg luxy-el" data-speed-y="-4">
           <img src="../assets/dc.png" alt="">
         </div>
         <p class="p1 f30">专家库名录</p>
         <p class="p2 f60">德才兼备，以德为先；重表现、看发展</p>
         <div class="more f18">
           <p>探索更多</p>
         </div>
       </div>
       <foot-Component></foot-Component>
     </div>
   </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import footComponent from '../components/foot'
  import Header from '../components/header'
  import  {getHomeInfo} from "../util/lang";
  import luxy from 'luxy.js';
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  export default {
  name: 'home',
    data(){
    let _this=this;
      return{
          swiperOption1: {
              loop: true,
              init: true,
              slidesPerView:1,
              speed:1000,
              autoplay: false,
              spaceBetween:50,
            navigation: {
              nextEl: '.btns .next',
              prevEl: '.btns .prev',
            },
            on:{
              slideChangeTransitionStart: function(){
                // alert(this.activeIndex);
                _this.tindex=this.realIndex
              },
            }
          },
        swiperOption2: {
          loop: true,
          init: true,
          slidesPerView:1.5,
          slideToClickedSlide: true,
          speed:1000,
          autoplay: false,
          spaceBetween:50
        },
        types:[
                "大院大所",
                "龙头企业",
                "集群企业",
                "服务机构"
        ],
        tindex:0,
        list:[
          {
            img:require('../assets/h1.png')
          },
          {
            img:require('../assets/h2.png')
          },
          {
            img:require('../assets/h1.png')
          },
          {
            img:require('../assets/h2.png')
          }
              ],
          data:{
              banner:[
                  {
                      img:require('../assets/banner.png')
                  },
                  {
                      img:require('../assets/banner.png')
                  }
              ],
              news:[]
          }
      }
    },
    mounted() {
        luxy.init({
            wrapper: '#luxy',
            targets: '.luxy-el',
            wrapperSpeed: 0.08
        });
      this.$refs.mySwipers.swiper.init()
      this.$refs.mySwipers2.swiper.init()
      const swiperTop = this.$refs.mySwipers.swiper
      const swiperThumbs = this.$refs.mySwipers2.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    },
  components:{bannerComponent,footComponent,Header,swiper, swiperSlide},
    methods:{
      goSlide(n){
        this.tindex=n
        this.$refs.mySwipers.swiper.slideToLoop(n,1000,false)
      },
        getHome(){
            const url = `${getHomeInfo()}`
            this.$axios.get(url).then(res => {
                this.data=res.data
            })
        },
        gotoInfo(id){
            const link=`/newsInfo.html?id=${id}`
            window.open(link,'_blank')
        },
        gotoAbout(){
            const link='/about.html'
            window.open(link,'_self')
        }
    }
}
</script>

<style lang="scss" scoped>
  .container{
    position: relative;
    #luxy {
      width: 100%;
      .section01{
        height:100vh;
        overflow: hidden;
      }
      .section02{
        padding: 80px 0;
        position: relative;
        overflow: hidden;
        .bg{
          position: absolute;
          left:0;
          top:-30vh;
          width:100%;
          height:100vh;
          background: url("../assets/hbg.png") no-repeat;
          background-size: cover;
          z-index: -1;
        }
        .content{
          width:95%;
          margin-left: 5%;
          .t1{
            color:#333333;
            font-size: 40px;
          }
          .nr{
            width:100%;
            display: flex;
            justify-content: space-between;
            margin: 40px auto;
            align-items: center;
            .l{
              width:48%;
              .types{
                display: flex;
                flex-wrap: wrap;
                p{
                  width:48%;
                  color:#204AA9;
                  opacity: 0.1;
                  font-size: 80px;
                  font-weight: bold;
                  margin-bottom: 30px;
                  transition: all 600ms;
                  cursor: pointer;
                }
                .active{
                  color:#C61D1E;
                  opacity: 1;
                }
                p:nth-child(3),p:nth-child(4){
                  text-align: right;
                }
              }
              .sw1{
                margin-top: 60px;
                .swiper{
                  .item{
                    .text{
                      .p1{
                        color:#333333;
                        font-size: 28px;
                      }
                      .des{
                        color:#666666;
                        font-weight: lighter;
                        line-height: 2.5;
                        margin: 30px 0;
                      }
                      .more{
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        p{
                          margin-left: 10px;
                          color:#C61D1E;
                          font-size: 14px;
                        }
                      }
                    }
                  }
                }
              }
              .btns{
                display: flex;
                align-items: center;
                margin-top: 60px;
                .prev{
                  width: 65px;
                  height: 65px;
                  background: #FFFFFF;
                  border-radius: 50%;
                  position: relative;
                  cursor: pointer;
                  transition: all 600ms;
                  transform: rotateY(180deg);
                  img{
                    position: absolute;
                    left:50%;
                    top:50%;
                    transform:translate(-50%,-50%);
                    transition: all 600ms;
                  }
                  img:nth-child(2){
                    opacity: 0;
                  }
                  &:hover{
                    background: #C61D1E;
                    img:nth-child(1){
                      opacity: 0;
                    }
                    img:nth-child(2){
                      opacity: 1;
                    }
                  }
                }
                .next{
                  width: 65px;
                  height: 65px;
                  background: #FFFFFF;
                  border-radius: 50%;
                  position: relative;
                  cursor: pointer;
                  transition: all 600ms;
                  margin-left: 30px;
                  img{
                    position: absolute;
                    left:50%;
                    top:50%;
                    transform:translate(-50%,-50%);
                    transition: all 600ms;
                  }
                  img:nth-child(2){
                    opacity: 0;
                  }
                  &:hover{
                    background: #C61D1E;
                    img:nth-child(1){
                      opacity: 0;
                    }
                    img:nth-child(2){
                      opacity: 1;
                    }
                  }
                }
              }
            }
            .r{
              width:48%;
              overflow: hidden;
              .swiper{
                width:100%;
                .item{
                  .pic{
                    overflow: hidden;
                    cursor: pointer;
                    img{
                      width:100%;
                      display: block;
                      object-fit: cover;
                      transition: all 2s;
                    }
                    &:hover{
                      img{
                        transform: scale(1.02);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .section03{
        position: relative;
        .content{
          width:90%;
          margin:80px auto;
          .t1{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .l{
              color:#333333;
              font-size: 40px;
              font-weight: lighter;
            }
            .r{
              display: flex;
              align-items: center;
              a{
                color:#333333;
                font-size: 20px;
                font-weight: bold;
                transition: all 600ms;
                margin-left: 40px;
                &:hover{
                  transform: scale(1.2);
                  color:#C61D1E;
                }
              }
              .active{
                transform: scale(1.2);
                color:#C61D1E;
              }
            }
          }
          .rnews{
            margin: 40px auto;
            .p1{
              color:#666666;
              font-size: 18px;
            }
            .p2{
              color:#333333;
              font-size: 40px;
              font-weight: bold;
              margin: 30px 0 40px 0;
            }
            .btn{
              display: flex;
              align-items: center;
              p{
                margin-left: 10px;
                color:#C61D1E;
              }
            }
          }
        }
        .allNews{
          display: flex;
          width:100%;
          justify-content: space-between;
          margin: 60px 0;
          .item{
            width:23.3%;
            border-top: 1px solid #C8C8C8;
            padding: 60px 5%;
            position: relative;
            border-bottom: 1px solid #C8C8C8;
            cursor: pointer;
            .bg{
              position: absolute;
              left:0;
              top:0;
              width:100%;
              height:100%;
              z-index: -1;
              transition: all 600ms;
              opacity: 0;
              img{
                width:100%;
                height:100%;
                object-fit: cover;
              }
            }
            .p1{
              color:#B9B9B9;
              font-size: 50px;
              font-weight: bold;
              transition: all 600ms;
            }
            .p2{
              color:#666666;
              font-weight: bold;
              margin-top: 10px;
              transition: all 600ms;
            }
            .p3{
              color:#333333;
              font-size: 28px;
              font-weight: bold;
              margin: 30px 0;
              transition: all 600ms;
            }
            .des{
              color:#666666;
              line-height: 1.8;
              transition: all 600ms;
            }
            .btn{
              display: flex;
              align-items: center;
              margin-top: 40px;
              transition: all 600ms;
              color:#C61D1E;
              p{
                margin-left: 10px;
              }
            }
            &:hover{
              .bg{
                opacity: 1;
              }
              .p1,.p2,.p3,.des,.btn{
                color:white;
              }
            }
          }
        }
        .gd{
          display: flex;
          justify-content: center;
          margin-bottom: 60px;
          cursor: pointer;
          p{
            color:#C61D1E;
            font-size: 18px;
          }
        }
      }
      .section04{
        width:100%;
        position: relative;
        overflow: hidden;
        padding:200px 0;
        .bg{
          position: absolute;
          left:0;
          top:-50vh;
          width:100%;
          height:120vh;
          background: url("../assets/ltbg.png") no-repeat;
          background-size: cover;
          z-index: -1;
        }
        .content{
          width:80%;
          margin: 0 auto;
          color:white;
          .t1{
            text-align: center;
            font-size: 40px;
          }
          .t2{
            text-align: center;
            font-weight: lighter;
            margin-top: 20px;
          }
          .pics{
            display: flex;
            flex-wrap: wrap;
            margin-top: 60px;
            .item{
              width:20%;
              height:100px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 20px;
              overflow: hidden;
              img{
                max-width: 80%;
                max-height: 100px;
                object-fit: contain;
                transition: all 600ms;
              }
              &:hover{
                img{
                  transform: scale(1.1);
                }
              }
            }
          }
        }
      }
      .section05{
        width:100%;
        position: relative;
        overflow: hidden;
       padding: 20vh 0;
        .bg{
          position: absolute;
          left:0;
          top:-60%;
          width:100%;
          height:120%;
          background: url("../assets/fwbg.png") no-repeat;
          background-size: cover;
          z-index: -1;
        }
        .content{
          width:90%;
          margin: 0 auto;
          .t1{
            color:#333333;
            font-size: 40px;
          }
          .t2{
            color:#333333;
            line-height: 2;
            margin-top:30px;
          }
          .more{
            display: flex;
            align-items: center;
            margin-top: 60px;
            p{
              color:#C61D1E;
              margin-left: 10px;
              font-weight: lighter;
            }
          }
          .allItems{
            margin-top: 400px;
            display: flex;
            justify-content:space-between;
            .item{
              width:48%;
              background: url("../assets/fw1.png") no-repeat;
              background-size: cover;
              .d1{
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #EEEEEE;
                .l{
                  width:30%;
                  text-align: center;
                  border-right: 1px solid #EEEEEE;
                  padding-top: 80px;
                  .pic{
                    width: 84px;
                    height: 84px;
                    background: #C61D1E;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;
                  }
                  p{
                    color:#333333;;
                    font-size: 23px;
                    margin-top: 15px;
                  }
                }
                .r{
                  width:60%;
                  padding: 80px 5%;
                  .p1{
                    color:#333333;
                    font-size: 26px;
                    line-height: 1.7;
                  }
                  .des{
                    color:#666666;
                    font-size: 18px;
                    font-weight: lighter;
                    margin-top: 40px;
                    line-height: 2;
                  }
                }
              }
              .d2{
                width:80%;
                margin: 20px auto;
                display: flex;
                align-items: center;
                p{
                  color:#999999;
                  font-size: 18px;
                  margin-left: 20px;
                }
              }
            }
          }
        }
      }
      .section06{
        padding: 200px 0;
        text-align: center;
        color:white;
        position: relative;
        width:100%;
        .bg{
          position: absolute;
          left:0;
          top:50%;
          width:100%;
          height:130%;
          z-index: -1;
          img{
            width:100%;
            height:100%;
            display: block;
            object-fit: cover;
          }
        }
        .p2{
          margin: 15px 0;
        }
        .more{
          margin-top: 40px;
        }
      }
      @media screen and (max-width: 1000px) {
      }
    }
  }
</style>
